/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import { Row, Col, Button, Card, Table } from "react-bootstrap";

import { useAuth, useDispatcher } from "../components/AuthProvider"
import { useSecureGet } from "../components/fetchHook";

import getPCPUrl from "../components/pcpUrl";
import {calcLastModified} from "../components/helpers";


const panel_div_style = {
  background: '#8DB0F8', // 0855F0 E2FEFF 8DB0F8

  margin: "5px 0px",
  padding: "7px"
}

let hdr_style = {

}



//---------------------------------------------------------------------------
//---------------------------------------------------------------------------

export default function ModelGallery() {
  const root_url = getPCPUrl();

  const [userModels, setUserModels] = useState([]);
  const [lastModelRefresh, setLastModelRefresh] = useState(Date.now());

  const navigate = useNavigate();
  const { session, currentModel } = useAuth();
  const dispatch = useDispatcher();


  const fetchData = async (method, endpoint, body) => {
    let url = root_url + endpoint;

    let results = {
      status: -1,
      body: null
    };


    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'PCPAuthorization': session.token
        },
        body: body // TODO fix this
      });

      results.status = response.status;
      if (results.status >= 200 && results.status <= 299) {
        results.body = await response.json();
      }
      //response.status
      //response.statusText 
    } catch (err) {
      console.log(err);
    }

    return results;
  }



  function handleRefreshModels() {
  }


  function handleLoadLocalModel() {
    // the local model has already been executed on startup by the time we get here
    navigate("/app/planner");
  }


  function setLoadedModel(model) {
    let action = {
      type: 'loadModel',
      body: model,
      lastSavedDate: model.lastSavedDate
    }

    dispatch(action);
    navigate("/app/planner");
  }


  function handleLoadModel(model) {
    const fd = async () => {
      var results = await fetchData("GET", "models/" + model.id, null);
      if (results.body !== null) {
        setLoadedModel(results.body);
      }
    }

    fd();
  }


  function handleDeleteModel(model) {
    const fd = async () => {
      var results = await fetchData("DELETE", "models/" + model.id, null);
      setLastModelRefresh(Date.now());
    }

    fd();
  }


  function handleSaveModel() {
    let model = currentModel.model;

    const fd = async () => {
      var results = await fetchData("POST", "models/" + model.modelID, JSON.stringify(model)); // TODO - fix this
    }

    fd();
  }


  const createEmptyModel = async (event) => {

    let birthdate = new Date();
    birthdate.setFullYear(birthdate.getFullYear() - 20);

    let body = {
      type: "empty", // empty, quick, template
      birthdate: birthdate
    }

    var results = await fetchData("POST", "models/create", JSON.stringify(body));
    if (results.body !== null) {
      setLoadedModel(results.body);
    }
  }


  const loadTemplate = async (id) => {

    let birthdate = new Date();
    birthdate.setFullYear(birthdate.getFullYear() - 20);

    let body = {
      type: "template", // empty, quick, template
      birthdate: birthdate,
      templateId: id
    }

    var results = await fetchData("POST", "models/create", JSON.stringify(body));
    if (results.body !== null) {
      setLoadedModel(results.body);
    }
  }



  return (
    <Row>
      <Col xs={12} sm={{ span: 8, offset: 2 }}>
        <CurrentModel model={currentModel} loadModel={handleLoadLocalModel} saveModel={handleSaveModel} />

        <SavedModels loadModel={handleLoadModel} deleteModel={handleDeleteModel} onRefresh={handleRefreshModels} />

        <EmptyPicker onEmptySelected={createEmptyModel} />

        <TemplatePicker onSelected={loadTemplate} />

      </Col>
    </Row>
  );

}

//---------------------------------------------------------------------------
//---------------------------------------------------------------------------

function CurrentModel(props) {

  if (props.model.model === null) {
    return null;
  }


  function onLoadModel(event) {
    event.preventDefault();
    props.loadModel();
  }

  function onSaveModel(event) {
    event.preventDefault();
    props.saveModel();
  }

  const title = "Resume";

  const new_row_style = {
    background: "#eeeeff"
  }


  return (
    <div>
      <Row style={new_row_style}>
        <Col >
          <h5>{title}</h5>
        </Col>
      </Row>

      <Row style={new_row_style}>
        <Col xs={12} sm={{ span: 8, offset: 2 }}>
          <CurrentModelPicker
            name={props.model.model.name}
            lastModified={props.model.lastUpdateDate}
            saveStatus={"xx"}
            onClick={onLoadModel}
            onSave={onSaveModel}
            onCopy={null}
          />
        </Col>
      </Row>
    </div>
  );
}


function CurrentModelPicker(props) {

  const comp_style = {
    margin: "10px 0px",
    width: "100%"
  }

  const name_style = {
    display: "inline-block",
    width: "30%"
  }

  const date_style = {
    display: "inline-block",
    width: "25%"
  }

  const button_style = {
    display: "inline-block",
    width: "5%"
  }

  const message_style = {

  }


  const save_icon = "fas fa-save fa-2x fa-fw";


  return (
    <div style={comp_style}>
      <span style={name_style} onClick={props.onClick}>{props.name}</span>
      <span style={date_style}>{calcLastModified(props.lastModified)}</span>
      <span style={button_style}><i className={save_icon} title="Save" onClick={props.onSave}></i></span>
      <span style={button_style}><i className={save_icon} title="Copy" onClick={props.onCopy}></i></span>
      <span style={message_style}>{props.saveStatus}</span>
    </div>
  )
}


//---------------------------------------------------------------------------
//---------------------------------------------------------------------------

function SavedModels(props) {
  const { getData, response, isLoading, error } = useSecureGet();
  const [models, setModels] = useState([]);


  async function load() {
    let url = getPCPUrl() + "models";
    await getData(url, "");
  };


  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    if (response !== null) {
      setModels(response);
    }
  }, [response]);


  function refeshModels(event) {
    event.preventDefault();

    load();
  }

  if (isLoading) {
    return <span>Loading saved models ...<i className="fas fa-spinner fa-spin"></i></span>
  }


  return (
    <div style={panel_div_style}>
      <h5 style={hdr_style}>Choose on of your saved model</h5><button onClick={refeshModels}>Refresh</button>
      <Row>
        <Col>
          {models.map(m => <SavedModel key={m.id} model={m} loadModel={props.loadModel} deleteModel={props.deleteModel} />)}
        </Col>
      </Row>
    </div>

  );
}


function SavedModel(props) {

  function onLoadModel(event) {
    event.preventDefault();
    props.loadModel(props.model);
  }

  function onDeleteModel(event) {
    event.preventDefault();

    if ( confirm("Are you sure !!") ) {
      props.deleteModel(props.model);
    }
  }

  const new_row_style = {
    padding: "5px"
  }

  return (
    <Row style={new_row_style}>
      <Col xs={8} onClick={onLoadModel}><span>{props.model.name}</span></Col>
      <Col><span>{calcLastModified(props.model.lastSavedDate)}</span></Col>
      <Col>
        <i className="fas fa-trash" title="Delete" onClick={onDeleteModel}></i>
      </Col>
    </Row>
  )

}

//---------------------------------------------------------------------------
//---------------------------------------------------------------------------


function EmptyPicker(props) {

  function handleEmpty(event) {
    event.preventDefault();

    props.onEmptySelected();
  }



  return (
    <div style={panel_div_style}>
      <h5 style={hdr_style}>Start from scratch</h5>
      <Row>
        <Col xs={6} sm={3}>
        <TemplateCard onSelected={props.onEmptySelected} id="0999" title="Blank model" desc="Bare minimum model" />
        </Col>
      </Row>

    </div>

  );
}

//---------------------------------------------------------------------------
//---------------------------------------------------------------------------

function TemplatePicker(props) {
  const { getData, response, isLoading, error } = useSecureGet();

  function handleClick(event) {
    event.preventDefault();

    props.onSelected();
  }


  /* TODO add to example book of react secrets :)
     https://stackoverflow.com/questions/74265321/uncaught-typeerror-destroy-is-not-a-function-error-in-react
    useEffect(async () => {
      let url = getPCPUrl() + "models/templates";
      await getData(url, "");
  
    }, []);
  */

  useEffect(() => {
    async function load() {
      let url = getPCPUrl() + "models/templates";
      await getData(url, "");
    };

    load();

  }, []);



  if (isLoading) {
    return <span>Loading templates ...<i className="fas fa-spinner fa-spin"></i></span>
  }


  return (
    <div style={panel_div_style}>
      <h5 style={hdr_style}>Start from one of our Templates</h5>
      <Row>
        <Col xs={6} sm={3}>
          <TemplateCard onSelected={props.onSelected} id="0001" title="Simple Life" desc="Minimal lifestyle, single income, a few typical expenses and not much else" />
        </Col>

        <Col xs={6} sm={3}>
          <TemplateCard onSelected={props.onSelected} id="0999" title="Complex demo" desc="Contains all the various types of accounts and transcations" />
        </Col>
      </Row>
    </div>

  );

}


function TemplateCard(props) {

  function handleClick(event) {
    event.preventDefault();

    props.onSelected(props.id);
  }


  return (
    <Card >
      <Card.Header>{props.title}</Card.Header>
      <Card.Body>
        <Card.Text>{props.desc}</Card.Text>

        <Button onClick={handleClick}>Select</Button>
      </Card.Body>
    </Card>

  );
}

